import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const headerVariants = cva('scroll-m-20 ', {
  variants: {
    variant: {
      h1: 'text-3xl md:text-4xl font-bold tracking-tight text-balance',
      h2: 'text-2xl md:text-3xl font-semibold tracking-tight border-b first:mt-0',
      h3: 'text-xl md:text-2xl font-semibold tracking-tight',
      h4: 'text-lg md:text-xl font-medium tracking-wide',
      h5: 'text-md font-medium',
    },
  },
})

function Header({
  className,
  variant,
  asChild = false,
  ...props
}: Omit<React.ComponentProps<'header'>, 'ref'> &
  VariantProps<typeof headerVariants> & {
    asChild?: boolean
  }) {
  // variant values ('h1'-'h5') double as the semantic heading tag to render, so
  // callers get real <h1>-<h5> markup instead of a styled, non-heading <header>.
  const Comp: React.ElementType = asChild ? Slot : (variant ?? 'header')

  return (
    <Comp
      data-slot="header"
      className={cn(headerVariants({ variant, className }))}
      {...props}
    />
  )
}

export { Header, headerVariants }
